export const auctionStyle = {
	wrapper: {
		position: 'relative',
		width: '100%',
		height: '100%',
		overflow: 'hidden',

		'& > .MuiBox-root': {
			borderRadius: '8px',
		},

		'@media (min-width: 1200px)': {
			minHeight: 'calc(100vh - 128px)',
			maxHeight: 'fit-content',
		},
	},

	loader: {
		position: 'absolute',
		left: '50%',
		top: '50%',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '1170px',
			width: '100%',
			height: '100%',
			padding: '48px 100px',
			scrollbarGutter: 'stable',

			'& .MuiButtonBase-root': {
				right: '0',
			},

			'& .MuiDialogTitle-root': {
				marginBottom: '40px',
			},

			'&.MuiDialog-root': {
				height: 'calc(100% - 80px)',
			},
		},
	},
};
